<template>
	<section role="main" class="content-body">
		<header class="page-header">
			<h2>意見反映</h2>
			<div class="right-wrapper">
				<ol class="breadcrumbs">
					<li>
						<router-link to="/">
							<i class="fa fa-home"></i>
						</router-link>
					</li>
					<li>意見反映</li>
				</ol>
			</div>
		</header>
		<main>
			<section class="panel panel-default" style="margin-bottom: 0px">
				<header class="panel-heading" style="padding: 10px;">
					<div class="panel-actions" style="top: 7px;">
						<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
					</div>
					<h4 class="panel-title">查詢條件</h4>
				</header>
				<div id="searchArea" class="panel-collapse collapse">
					<div class="panel-body">
						<div class="row form-group">
							<div class="col-md-4">
								<label class="col-md-4">學年度</label>
								<div class="col-md-8">
									<select v-model="qryParam.smtr" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(item, index) in selectSmtr" :key="index" :value="item.value">{{item.text}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">系所</label>
								<div class="col-md-8">
									<select v-model="qryParam.deptCode" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(dept, index) in deptCodeList" :key="index" :value="dept.commCode">{{dept.commValue}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4">
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-4">
								<label class="col-md-4">學生姓名</label>
								<div class="col-md-8">
									<input type="text" v-model="qryParam.name" class="form-control"/>
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">學號</label>
								<div class="col-md-8">
									<input type="text" v-model="qryParam.account" class="form-control"/>
								</div>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-md-4 "></div>
							<div class="col-md-4 ">
								<div class="col-md-offset-3 col-md-6">
									<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
								</div>
							</div>
							<div class="col-md-4 "></div>
						</div>
					</div>
				</div>
			</section>
			<div class="tab-content">
				<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
					<div class="row form-group">
						<div class="col-md-12 text-right form-inline" v-if="this.sessionData.accountType == 'STU'">
							<button class="btn btn-primary hidden-xs" @click="gotoView('tenancyOpinionbackEdit', {account:sessionData.account, })">新增意見反映</button>
							<button class="btn btn-primary btn-block visible-xs" @click="gotoView('tenancyOpinionbackEdit', {account:sessionData.account})">新增意見反映</button>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-12 form-group">
							<table class="table table-no-more table-bordered table-striped mb-none" style="width:100% !important;">
								<thead>
									<tr>
										<th class="text-center" style="width:10%">學年度</th>
										<th class="text-center" style="width:10%">系所名稱</th>
										<th class="text-center" style="width:10%">班級</th>
										<th class="text-center" style="width:10%">學號</th>
										<th class="text-center" style="width:10%">學生姓名</th>
										<th class="text-center" style="width:10%">電話</th>
										<th class="text-center" style="width:10%">意見反映</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, key) in gridList.rows" :key="key">
										<td data-title="學年度" class="text-center">{{item.smtr}}</td>
										<td data-title="系所名稱" class="text-center">{{item.deptName}}</td>
										<td data-title="班級" class="text-center">{{`${item.drade}年${item.dradeClass}班`}}</td>
										<td data-title="學號" class="text-center">{{item.account}}</td>
										<td data-title="學生姓名" class="text-center">{{item.name}}</td>
										<td data-title="電話" class="text-center">{{item.phone}}</td>
										<td data-title="意見反映" class="text-center" v-if="sessionData.accountType == 'STU'">{{sortStr(item.opinion)}}</td>
										<td data-title="意見反映" class="text-center" v-else>
											<a class="btn btn-link" @click="gotoView('tenancyOpinionbackEdit', {account:item.account, opinion: item.opinion})">{{sortStr(item.opinion)}}</a>
										</td>
									</tr>
								</tbody>
							</table>
							
						</div>
						<div class="col-md-12">
							<div class="text-center">
								<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
	</section>
</template>
<script>
export default {
	data(){
		return {
			page: 1,
			totalPage: 0,
			qryParam:{
				smtr :"",
				deptCode:"",
				name:"",
				account:""
			},
			deptCodeList:[],
			gridList:[],
		}
	},
	mounted(){
		this.qryParam.smtr = this.nowMonth;
		this.init();
		this.gridInit();
	},
	methods:{
		init(){
			const api = "/api/Common/commCodeList/DEPT";
			this.$axios.post(api).then(resp =>{
				this.deptCodeList = resp.data.data;
			});
		},
		gridInit(){
			const api = "/api/TenancyOpinionBack/stuOpinionData";
			this.$axios.post(api, JSON.stringify({
				model:this.qryParam,
				page:this.page,
				pageSize:10
			})).then(resp =>{
				this.gridList = resp.data.data;
				this.totalPage = this.gridList.total;
				this.page = this.gridList.page;
			});
		},
		updateGrid(page) {
			//更新Grid 必需
			this.page = page;
			this.gridInit();
		},
		sortStr(val){
			if(val.length > 20){
				return val.substring(0, 20);
			}
			return val;
		}
	},
	computed:{
		selectSmtr(){
			let smtrArray = [];
			let nowYear = (new Date().getFullYear() - 1911);
			let nowMonth = new Date().getMonth() + 1;
			if(nowMonth < 8){
				nowYear = nowYear-1;
			}
			for(let y = nowYear; y > 100 ; y--){
				if((y == nowYear && nowMonth < 8) || y < nowYear){
					smtrArray.push({text:y+"年第二學期",value:y+"2"});
				}
				smtrArray.push({text:y+"年第一學期",value:y+"1"});
			}
			return smtrArray;
		}
	}
}
</script>